// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3sEgi","label":"LabeledBox_label__QBv0y"};